<template>
  <b-overlay :show="dataList.length < 0" rounded="sm" opacity="0.5" blur="none">
    <div class="row">
      <div class="col-md-4 my-2">
        <slot name="beforeAdd"></slot>
        <b-button
            squared
            class="col-md-12 my-3 text-center"
            variant="primary"
            @click="switchOnAdd"
        >
          <i class="fa fa-plus" aria-hidden="true"></i>
        </b-button>
        <b-list-group class="list-group list-group-flush scroll">
          <b-list-group-item
              class="list-group-item list-group-item-action"
              v-for="(item,key) in list" :key="item.id"
              href="#"
              @click="switchOnUpdate(item)"
              :class="{ 'active': index === key }"
          >
            <!-- Slot Affichage --->
            <slot name="listItem" v-bind:listItem="item"></slot>
          </b-list-group-item>
        </b-list-group>
      </div>

      <div class="col-md-8">
        <div class="card">
          <div class="card-body">
            <!--- Slot formulaire --->
             <slot v-bind:form="{item, operation }"></slot>
          </div>
        </div>
      </div>
    </div>
  </b-overlay>
</template>

<script>
import {mapActions, mapState} from "vuex";

export default {
  name: 'Crud-List',
  props:['dataList'],
  computed:{
    ...mapState('crudList',['list','operation','item','index'])
  },
  methods:{
    ...mapActions('crudList',['loadList','setIndex','setCurrentItem','switchOnUpdate','switchOnAdd'])
  },
  created() {
    this.loadList(this.dataList)
  },
  data() {
    return {
      items: [
        { age: 40, first_name: 'Dickerson', last_name: 'Macdonald' },
        { age: 21, first_name: 'Larsen', last_name: 'Shaw' },
        { age: 89, first_name: 'Geneva', last_name: 'Wilson' },
        { age: 38, first_name: 'Jami', last_name: 'Carney' }
      ]
    }
  }
}
</script>

<style scoped>
.scroll{
    max-height: 10rem; 
    overflow-y: scroll;
  }
@media (min-width: 576px) {
  .scroll{
    max-height: 10rem; 
    overflow-y: scroll;
  }
}

@media (min-width: 768px) {
  .scroll{
    max-height: 45rem; 
    overflow-y: scroll;
  }
}

@media (min-width: 992px) {
  .scroll{
    max-height: 24rem; 
    overflow-y: scroll;
  }
}

@media (min-width: 1200px) {
  .scroll{
    max-height: 30rem; 
    overflow-y: scroll;
  }
}
/* width */
::-webkit-scrollbar {
  width: 15px;
}

/* Track */
::-webkit-scrollbar-track {
  box-shadow: inset 0 0 1px grey; 
  border-radius: 0px;
}
 
/* Handle */
::-webkit-scrollbar-thumb {
  background: grey; 
  border-radius: 0px;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: grey; 
}


.btn{
  border-radius: 0px;
}
</style>
